export default "__VITE_ASSET__BRJg669k__"